import { SCANS_API } from "./CONSTANTS";
import customAxios from "./customAxios";

export interface ScanNotificationRequest {
  subscriberId: string;
  scanMethod: string;
}

export interface EmailRecipient {
  email: string;
  name: string;
  relationship: string;
}

export interface ScanNotificationResponse {
  success: boolean;
  message: string;
  emailsSent: number;
  recipients: EmailRecipient[];
}

export const sendScanNotification = (
  notificationData: ScanNotificationRequest
): Promise<ScanNotificationResponse> => {
  return new Promise((resolve, reject) => {
    try {
      customAxios
        .post(`${SCANS_API}dummy/scan-notification`, notificationData)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};
